import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoDestinoLixoEnum } from 'graphql/types.generated'

import { tipoDestinoLixoEnumRecord, tipoDestinoLixoValidoEnumList } from './condicoes-moradia-model'

export type TipoDestinoLixoSelectFieldProps = CustomSelectFieldProps<TipoDestinoLixoEnum> & {
  showItensLegados: boolean
}

export function TipoDestinoLixoSelectField(props: TipoDestinoLixoSelectFieldProps) {
  const items = props.showItensLegados ? allItems : tipoDestinoLixoValidoEnumList
  return <SelectField<TipoDestinoLixoEnum> items={items} itemToString={itemToString} {...props} />
}

const allItems = Object.values(TipoDestinoLixoEnum)
const itemToString = (item: TipoDestinoLixoEnum) => item && tipoDestinoLixoEnumRecord[item]
